import { orderStatus } from 'utils/orderStatus';

export default {
    [orderStatus[0]?.name]: [
        {
            name: 'Requested',
            status: orderStatus[0]?.name,
        },
        {
            name: 'Manager Approval',
            status: orderStatus[1]?.name,
        },
        {
            name: 'Provisioning',
            status: 'wait',
        },
        {
            name: orderStatus[4]?.name,
            status: 'wait',
        },
    ],
    [orderStatus[1]?.name]: [
        {
            name: 'Requested',
            status: orderStatus[0]?.name,
        },
        {
            name: 'Manager Approval',
            status: orderStatus[4]?.name,
        },
        {
            name: 'Provisioning',
            status: orderStatus[1]?.name,
        },
        {
            name: orderStatus[4]?.name,
            status: 'wait',
        },
    ],
    [orderStatus[2]?.name]: [
        {
            name: 'Requested',
            status: orderStatus[0]?.name,
        },
        {
            name: 'Cancelled',
            status: orderStatus[3]?.name,
        },
    ],
    [orderStatus[3]?.name]: [
        {
            name: 'Requested',
            status: orderStatus[0]?.name,
        },
        {
            name: 'Manager Approval',
            status: orderStatus[3]?.name,
        },
        {
            name: 'Provisioning',
            status: 'wait',
        },
    ],
    [orderStatus[4]?.name]: [
        {
            name: 'Requested',
            status: orderStatus[0]?.name,
        },
        {
            name: 'Manager Approval',
            status: orderStatus[4]?.name,
        },
        {
            name: 'Provisioning',
            status: orderStatus[4]?.name,
        },
        {
            name: 'Completed',
            status: orderStatus[4]?.name,
        },
    ],
    [orderStatus[5]?.name]: [
        {
            name: 'Requested',
            status: orderStatus[0]?.name,
        },
        {
            name: 'Action Required',
            status: orderStatus[5]?.name,
        },
        {
            name: 'Manager Approval',
            status: 'wait',
        },
        {
            name: 'Provisioning',
            status: 'wait',
        },
        {
            name: 'Completed',
            status: 'wait',
        },
    ],

    [orderStatus[6]?.name]: [
        {
            name: 'Requested',
            status: orderStatus[0]?.name,
        },
        {
            name: 'Manager Approval',
            status: orderStatus[4]?.name,
        },
        {
            name: 'Provisioning',
            status: orderStatus[4]?.name,
        },
        {
            name: orderStatus[4]?.name,
            status: orderStatus[1]?.name,
        },
    ],
};
